// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"ScatterTable_tableRow__1XXSI"};